import { forwardRef } from 'react';

// mui
import { Tooltip, Stack, SvgIcon, useTheme } from '@mui/material';

// icon
import { Verified as VerifiedIcon } from '@mui/icons-material';

const LoiseBadgeIcon = forwardRef((props, ref) => {
    const theme = useTheme();
    return (
        <SvgIcon {...props} ref={ref} viewBox='0 0 24 24'>
            {/* badge outline — same starburst shape as MUI Verified */}
            <path d='M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.7 3.1 5.51l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82 1.89 3.2 3.4-1.47 3.4 1.47 1.89-3.2 3.61-.82-.34-3.69L23 12z' />
            {/* L letter */}
            <text
                x='12.5'
                y='12.5'
                textAnchor='middle'
                dominantBaseline='central'
                fontSize='11'
                fontWeight='bold'
                fill={theme.palette.primary.contrastText}
                fontFamily='montserrat'>
                L
            </text>
        </SvgIcon>
    );
});

function UserBadges(props) {
    return (
        <Stack direction='row' alignItems='center' gap={1} sx={{ ml: 0.5 }}>
            {props.badges?.verified && (
                <Tooltip title='verified'>
                    <VerifiedIcon sx={{ ml: 0.5, fontSize: '1rem', color: 'primary.light' }} />
                </Tooltip>
            )}
            {props.badges?.membership && (
                <Tooltip title='membership'>
                    <LoiseBadgeIcon sx={{ ml: 0.5, fontSize: '1rem', color: 'primary.light' }} />
                </Tooltip>
            )}
        </Stack>
    );
}

export { UserBadges };
